import React, { useState } from 'react';
import {
  DisplayAboveMobile,
  DisplayOnMobile,
  SectionContainer,
  StyledBox,
  TextPairingContainer,
  VideoWrapper,
} from './SmartRSVPSectionV2.styles';
import { CTALink } from '@components/CTALink';
import { Box } from '@components/Box';
import { VimeoVideo } from '@components/VimeoVideo';
import { useTranslation } from 'react-i18next';

export const SmartRSVPSectionV2: React.FC = () => {
  const { t } = useTranslation('weddingInvitations');
  const invitationSmartRSVPSectionV2 = t('invitationSmartRSVPSectionV2');
  const sectionId = 'WeddingInvitationSmartRSVPSection';
  return (
    <SectionContainer id={sectionId} paddingTop={8}>
      <StyledBox>
        <TextPairingContainer
          eyebrow={invitationSmartRSVPSectionV2.eyebrow}
          eyebrowColor="humana2"
          eyebrowVariant={'sectionEyeBrow20'}
          eyebrowTagName="h2"
          title={invitationSmartRSVPSectionV2.title}
          titleVariant={'hed56'}
          titleColor="neutra1"
          titleTagName="h2"
          body={invitationSmartRSVPSectionV2.body}
          bodyColor="neutra1"
          bodyVariant="featureCopy17"
        />
        <Box marginTop={['24px']}>
          <CTALink id="exploreGuestList" hasChevron={true} variant="alternative" typography="featureHed17" href="/online-rsvp">
            {invitationSmartRSVPSectionV2.exploreRSVP}
          </CTALink>
        </Box>
      </StyledBox>
      <DisplayAboveMobile>
        <VideoWrapper>
          <VimeoVideo
            posterUrl={invitationSmartRSVPSectionV2.desktop.posterUrl}
            embedUrl={invitationSmartRSVPSectionV2.desktop.videoUrl}
            title={invitationSmartRSVPSectionV2.title}
            autoPlay
            background
            controls={false}
            autoPause={false}
            alt="create-invite"
            muted
            loop
            cover
            posterOptimization="aggressive"
          />
        </VideoWrapper>
      </DisplayAboveMobile>
      <DisplayOnMobile>
        <VideoWrapper>
          <VimeoVideo
            posterUrl={invitationSmartRSVPSectionV2.mobile.posterUrl}
            embedUrl={invitationSmartRSVPSectionV2.mobile.videoUrl}
            title={invitationSmartRSVPSectionV2.title}
            autoPlay
            background
            controls={false}
            autoPause={false}
            alt="create-invite"
            muted
            loop
            cover
            posterOptimization="aggressive"
            aspectRatio={0.51}
          />
        </VideoWrapper>
      </DisplayOnMobile>
    </SectionContainer>
  );
};
